angular
  .module('customer')

  .factory('CustomerExport', [
    '$http',
    '$timeout',
    '$filter',
    'Dialog',
    function($http, $timeout, $filter, Dialog) {
      const download = () => {
        const url = '@@apiUrl' + '/customers-export-csv';
        const exportParams = { method: 'POST', url };

        $http(exportParams)
          .then(() => {
            $timeout(
              () =>
                new Dialog().info(
                  $filter('translate')('EXPORT_EMAIL_SUCCESS_1') +
                    '\n' +
                    $filter('translate')('EXPORT_EMAIL_SUCCESS_2')
                ),
              200
            );
          })
          .catch(error => {
            Sentry.captureException(error);
            $timeout(
              () =>
                new Dialog().error($filter('translate')('error.RECEIVE_ERR')),
              200
            );
          });
      };

      return { download };
    }
  ]);
